export default {"src":"/_next/static/media/icon-dollar.0db84175.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};